import { useTheme } from "@vapor/react-material";
import { useCallback } from "react";
import { toast } from "react-toastify";

export const useSuccessNotification = () => {
    const theme = useTheme();

    const showTextMessage = useCallback(
        (message: string) => {
            toast.success(message, {
                position: "top-right",
                hideProgressBar: true,
                style: {
                    border: "1px solid",
                    borderBottomWidth: "4px",
                    borderColor: theme.palette.primary.successed,
                },
            });
        },
        [theme],
    );

    return { showTextMessage };
};
